module.exports = __webpack_public_path__ + "images/檀程长图_06.jpg?v=ca3264d5";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan4/檀程长图_06.jpg
 ** module id = 196
 ** module chunks = 1 2
 **/